__webpack_require__.p = "/monday/bb/v1/config/";